import api from './interceptor';

const BASE_URL = 'api/v2/support-tickets';

export default {
  createTicket: (params, files = []) => {
    if (files.length === 0) {
      return api.post(BASE_URL, params);
    }
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    });
    files.forEach((file) => {
      formData.append('attachments', file);
    });
    return api.post(BASE_URL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
